import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "../../lib/mrs";

export const EditorialMarquee = () => {
  return (
    <section
      data-testid="marquee-section"
      className="relative bg-[#0a0b0a] py-10 md:py-14 overflow-hidden"
    >
      <Marquee speed={38} gradient={false} autoFill>
        {MARQUEE_ITEMS.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display font-light text-[#eae7e0]/85 text-4xl md:text-6xl lg:text-7xl tracking-tight px-8 md:px-12">
              {item}
            </span>
            <span className="text-[#b89b72] text-2xl md:text-4xl">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};
